/**
 * Zugriff auf localStorage, der nie wirft (privates Fenster, gesperrter Speicher, Kontingent voll).
 * `ok` meldet, ob dauerhaft gespeichert werden kann – sonst warnt die App vor dem Schließen.
 */
export const storage = {
  ok: probe(),
  get<T>(key: string): T | undefined {
    try {
      const raw = localStorage.getItem(key);
      return raw == null ? undefined : (JSON.parse(raw) as T);
    } catch {
      return undefined;
    }
  },
  set(key: string, value: unknown): boolean {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  },
  remove(key: string) {
    try {
      localStorage.removeItem(key);
    } catch {
      /* egal */
    }
  },
};

function probe(): boolean {
  try {
    const k = '__werft_probe';
    localStorage.setItem(k, '1');
    localStorage.removeItem(k);
    return true;
  } catch {
    return false;
  }
}

/** Kennung dieses Tabs; bleibt über Neuladen erhalten (sessionStorage), ist aber je Tab verschieden */
export function tabId(): string {
  try {
    let id = sessionStorage.getItem('werft.tab');
    if (!id) {
      id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      sessionStorage.setItem('werft.tab', id);
    }
    return id;
  } catch {
    return 'mem-' + Math.random().toString(36).slice(2, 10);
  }
}
